import { Button } from '@life-line-lab/components-react';
import { FormAction } from 'Components/base';
import UploadEPrescriptionContainer from 'Components/e-prescription/upload-e-prescription-container';
import { getBase64 } from 'Helpers/getbase64';
import { toaster } from 'Helpers/toaster';
import useLLLForm from 'Hooks/form.hook';
import useSession from 'Hooks/session.hook';
import { RequestType, Status } from 'Models/quotation-request';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { createQuotationRequest } from 'Services/quotation-request.services';
import './e-prescription-quotation.scss';
import { ePrescriptionQuotationSchema } from './e-prescription-quotation.validation';

type Props = {};

export interface EPrescriptionQuotationFormType {
  files: any[];
}

const EPrescriptionQuotation = (props: Props) => {
  const { t } = useTranslation();
  const { profile } = useSession();
  const history = useHistory();

  const { values, setValues, formSubmitState, onSubmit, errors, onCancelSubmit } =
    useLLLForm<EPrescriptionQuotationFormType>({
      initialValues: {
        files: [],
      },
      yupSchema: ePrescriptionQuotationSchema,
    });

  const handleCreateQuotationRequest = async () => {
    const filesData: any[] = [];
    for (const file of values.files) {
      const base64String = await getBase64(file.originFileObj) as string;
      filesData.push({
        fileName: file.name,
        fileType: file?.type?.split('/')?.[1] === 'pdf' ? 'DOCUMENT' : 'IMAGE',
        base64String,
      });
    }
    const response = await createQuotationRequest({
      // @ts-ignore
      sourceSite: process.env.ACCOUNT_TYPE,
      requestedBy: profile?._id,
      requestType: RequestType.PRESCRIPTION,
      status: Status.OPEN,
      files: filesData,
    })
    if (!response || response.error) {
      toaster('error', t('toaster.failedSubmitEPrescription'));
      onCancelSubmit();
      return;
    }

    toaster('success', t('toaster.successSubmitEPrescription'));
    onCancelSubmit();
    history.push('/purchase');
  }

  useEffect(() => {
    if (!formSubmitState.isSubmitting) return;

    handleCreateQuotationRequest();
  }, [formSubmitState.isSubmitting]);

  return (
    <div className="e-prescription-quotation">
      <UploadEPrescriptionContainer
        isError={!!errors['files']}
        title={'Upload e-prescription'}
        handleFilesChange={(fileList: any[]) =>
          setValues((prevState) => ({ ...prevState, files: fileList }))
        }
        handleRemoteFilesToRemove={(fileID: string) => {}}
        fileList={values.files}
        footer={
          <FormAction>
            <Button
              type="primary"
              label={t('action.submit')}
              size={'large'}
              onClick={onSubmit}
              isLoading={formSubmitState.isSubmitting}
            />
          </FormAction>
        }
      />
    </div>
  );
};

export default EPrescriptionQuotation;
